import type {
  ClientOrganization,
  ClientOrganizationTagsEnum
} from '@DigitaleDoerfer/digitale-doerfer-api';

export const isOrganizationType = (
  type: ClientOrganizationTagsEnum,
  organization: ClientOrganization | undefined
): boolean => organization?.tags?.includes(type) ?? false;
